"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsCompanyNumber = void 0;
const class_validator_1 = require("class-validator");
let IsCompanyNumber = class IsCompanyNumber {
    validate(rawCompanyIdNumber) {
        if (!rawCompanyIdNumber) {
            return false;
        }
        const containsAtLeastOneNumber = /^.*[0-9]+.*$/.test(rawCompanyIdNumber);
        const containsAllowedCharacters = /^[/\-.A-Za-z0-9]*$/.test(rawCompanyIdNumber);
        const isValid = containsAtLeastOneNumber && containsAllowedCharacters;
        return isValid;
    }
    defaultMessage() {
        return "Company ID NUMBER must contain at least one digit and no spaces. Allowed special characters: /-.";
    }
};
exports.IsCompanyNumber = IsCompanyNumber;
exports.IsCompanyNumber = IsCompanyNumber = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is company ID number" })
], IsCompanyNumber);
//# sourceMappingURL=IsCompanyNumber.js.map